function fromComparisonFunction(comparisonFunction, field, direction) {
    if (!field && direction !== 'desc') {
        return comparisonFunction
    }

    let target = nestedFieldComparison(comparisonFunction, field)

    if (direction === 'desc') {
        return (lhs, rhs) => target(rhs, lhs)
    }

    return target
}

function nestedFieldComparison(comparisonFunction, field) {
    if (typeof field === 'function') {
        return (lhs, rhs) => comparisonFunction(field(lhs) ?? null, field(rhs) ?? null)
    }
    if (typeof field === 'string') {
        return (lhs, rhs) => comparisonFunction(lhs?.[field] ?? null, rhs?.[field] ?? null)
    }

    return comparisonFunction
}

export const date = {
    comparer(lhs, rhs) {
        if (!!lhs !== !!rhs) {
            return lhs ? 1 : -1
        }

        var result = (lhs.year || 0) - (rhs.year || 0)

        if (result != 0) {
            return result
        }

        result = (lhs.month || 0) - (rhs.month || 0)

        if (result != 0) {
            return result
        }

        return (lhs.day || 0) - (rhs.day || 0)
    },
    create(field, direction) {
        return fromComparisonFunction(this.comparer, field, direction)
    },
    sort(array, field, direction) {
        return array.slice(0).sort(this.create(field, direction))
    },
}

export const workHistory = {
    comparer(lhs, rhs) {
        const lhsCurrent = !!lhs.current
        const rhsCurrent = !!rhs.current

        if (lhsCurrent !== rhsCurrent) {
            return lhsCurrent ? -1 : 1
        }

        var result = date.comparer(lhs.endDate, rhs.endDate)

        if (result !== 0) {
            return -result
        }

        return -date.comparer(lhs.startDate, rhs.startDate)
    },
    create(field, direction) {
        return fromComparisonFunction(this.comparer, field, direction)
    },
    sort(array, field, direction) {
        return array.slice(0).sort(this.create(field, direction))
    },
}
